import template from './ratings_report.html';
import tr from '../../../lib/default-translator.js';

class ReportRatingsViewModel
{
	constructor(page)
	{

		this.page = page;
		this.include_resigned = ko.observable(false);
		this.results = ko.observable([]);

		this.current_page_number = ko.observable(1);
		this.current_page_size = ko.observable(15);
		this.page_count = ko.observable(1);
		this.number_of_records = ko.observableArray([15, 20, 50, 100, 200]);
		this.selected_number_of_records = ko.observable(15);

		this.sort_field = ko.observable('Employee');
		this.sort_order = ko.observable('ASC');

		this.current_department_id = ko.observable(null);
		this.current_company_id = ko.observable(null);

		this.selected_company = ko.observable();
		this.selected_department = ko.observable();
		this.selected_employee = ko.observable();
		this.selected_cycle = ko.observable();
		this.selected_filter_by = ko.observable('employee');
		this.selected_manager = ko.observable();
		this.steps = ko.observable();
		this.show_hint = ko.observable(true);
		this.show_no_data_message = ko.observable(false);

		this.show_emp_rating = ko.observable(false);

		this.selected_number_of_records.subscribe((newVal) => {
			this.current_page_size(newVal);
			this.page.updateData();
		});

		// Modified: Clear results and show hint instead of updating data
		this.selected_manager.subscribe((value) => {
			this.results([]);
			this.show_hint(true);
			this.show_no_data_message(false);
		})

		this.include_resigned.subscribe((value) => {
			this.results([]);
			this.show_hint(true);
			this.show_no_data_message(false);
		})

		this.selected_company.subscribe((value) => {
			this.results([]);
			this.show_hint(true);
			this.show_no_data_message(false);
		})

		this.selected_department.subscribe((value) => {
			this.results([]);
			this.show_hint(true);
			this.show_no_data_message(false);
		});

		this.selected_cycle.subscribe((value) => {
			this.results([]);
			this.show_hint(true);
			this.show_no_data_message(false);
		});

		this.selected_employee.subscribe((value) => {
			this.results([]);
			this.show_hint(true);
			this.show_no_data_message(false);
		});

		this.cycle_names = ko.computed(() => {
			//set the cycle names for the table header
			let names = [...new Set(this.results().map(r => r.cycle_name).filter(name => name !== null))];
			return names;
		});

		this.selected_filter_by.subscribe((value) => {
			this.results([]);
			this.show_hint(true);
			this.show_no_data_message(false);
		})

		//visible columns
		this.columns = ko.observableArray(['Employee', 'Company', 'Department']);
		this.visible_columns = ko.observableArray(['Employee', 'Company', 'Department']);
	
		// Update columns when cycle names change
		this.cycle_names.subscribe((new_cycle_names) => {
			// Add cycle names to columns
			let cycle_columns = new_cycle_names.map(cycle_name => cycle_name);
			this.columns(['Employee', 'Company', 'Department', ...cycle_columns]);

			if (this.selected_cycle())
			{
				this.columns(['Employee', 'Company', 'Department', this.selected_cycle().cycle_name]);
				this.visible_columns(['Employee', 'Company', 'Department', this.selected_cycle().cycle_name]);
			}
			else
				this.visible_columns(['Employee', 'Company', 'Department', ...cycle_columns]);
		});

		this.grouped_results = ko.computed(() => {
		    let results = this.results();
		    let selected_cycle = this.selected_cycle();
		    let show_emp_rating = this.show_emp_rating();

		    let filtered_results = results.filter(result => {
		        if (!selected_cycle) return true;
		        // Include employees with no cycle (no ratings) or matching cycle
		        return !result.cycle_name || result.cycle_name === selected_cycle.cycle_name;
		    });
		
		    let groups = filtered_results.reduce((acc, result) => {
		        let key = result.first_name + ' ' + result.last_name;
			
		        if (!acc[key]) {
		            acc[key] = {
		                employee_name: key,
		                employee_id: result.employee_id,
		                department_name: result.department,
		                company_name: result.company,
		                cycle_ratings: {},
		                has_ratings: false
		            };
		        }
			
		        // If employee has ratings
		        if (result.cycle_name && result.rating) {
		            acc[key].has_ratings = true;
		            
		            if (!acc[key].cycle_ratings[result.cycle_name]) {
		                acc[key].cycle_ratings[result.cycle_name] = {
		                    manager_ratings: [],
		                    employee_ratings: []
		                };
		            }
				
		            // Create a unique key for each rating system
		            let rating_key = `${result.rating_system_id}_${result.rating_system_name}`;
		            
		            // Separate manager and employee ratings - store as arrays grouped by rating system
		            if (result.rating_type === 'manager') {
		                // Check if this rating system already exists
		                let existing_rating = acc[key].cycle_ratings[result.cycle_name].manager_ratings
		                    .find(r => r.rating_system_id === result.rating_system_id);
		                
		                if (!existing_rating) {
		                    acc[key].cycle_ratings[result.cycle_name].manager_ratings.push({
		                        rating_system_id: result.rating_system_id,
		                        rating_system_name: result.rating_system_name,
		                        ratings: [{
		                            rating: result.rating,
		                            rating_symbol: result.rating_symbol,
		                            rating_name: result.rating_name,
		                            rating_id: result.rating_id
		                        }]
		                    });
		                } else {
		                    // Add to existing rating system
		                    existing_rating.ratings.push({
		                        rating: result.rating,
		                        rating_symbol: result.rating_symbol,
		                        rating_name: result.rating_name,
		                        rating_id: result.rating_id
		                    });
		                }
		            } else if (result.rating_type === 'employee' && show_emp_rating) {
		                // Same logic for employee ratings
		                let existing_rating = acc[key].cycle_ratings[result.cycle_name].employee_ratings
		                    .find(r => r.rating_system_id === result.rating_system_id);
		                
		                if (!existing_rating) {
		                    acc[key].cycle_ratings[result.cycle_name].employee_ratings.push({
		                        rating_system_id: result.rating_system_id,
		                        rating_system_name: result.rating_system_name,
		                        ratings: [{
		                            rating: result.rating,
		                            rating_symbol: result.rating_symbol,
		                            rating_name: result.rating_name,
		                            rating_id: result.rating_id
		                        }]
		                    });
		                } else {
		                    existing_rating.ratings.push({
		                        rating: result.rating,
		                        rating_symbol: result.rating_symbol,
		                        rating_name: result.rating_name,
		                        rating_id: result.rating_id
		                    });
		                }
		            }
		        }
		        return acc;
		    }, {});
		
		    return Object.values(groups);
		});

		// Modified: Clear results and show hint instead of updating data
		this.show_emp_rating.subscribe(() => {
			if (this.results().length > 0) {
				// Only update if there's already data loaded
				this.page.updateData();
			}
		});

		this.paginated_results = ko.computed(() => {
			let sorted = this.grouped_results();

			// Sorting logic
			sorted.sort((a, b) => {
				let field = this.sort_field();
				let order = this.sort_order();

				let valueA, valueB;
				switch(field) {
					case 'Employee':
						valueA = a.employee_name;
						valueB = b.employee_name;
						break;
					case 'Company':
						valueA = a.company_name;
						valueB = b.company_name;
						break;
					case 'Department':
						valueA = a.department_name;
						valueB = b.department_name;
						break;
					default:
						// For cycle columns - sort by first rating system's first rating symbol
						valueA = a.cycle_ratings[field]?.manager_ratings?.[0]?.ratings?.[0]?.rating_symbol || '';
						valueB = b.cycle_ratings[field]?.manager_ratings?.[0]?.ratings?.[0]?.rating_symbol || '';
				}

				if (valueA < valueB) return order === 'ASC' ? -1 : 1;
				if (valueA > valueB) return order === 'ASC' ? 1 : -1;
				return 0;
			});

			// Pagination
			let page_number = this.current_page_number();
			let page_size = this.current_page_size();
			let start_index = (page_number - 1) * page_size;
			let end_index = start_index + page_size;

			// Update page count
			this.page_count(Math.ceil(sorted.length / page_size));

			return sorted.slice(start_index, end_index);
		});
	}

	show_report_help()
	{
		Grape.dialog.open('PerformanceCycleRatingsHelp', { employee_id: this.page.bindings.id });
	}

	download_clicked()
	{
		let current_visible_columns = this.columns().filter(column => this.visible_columns().includes(column));
		let csv_content = [];
	
		// Create header row
		let header_row = current_visible_columns.map(column => {
			if (column === 'Employee' || column === 'Company' || column === 'Department') 
				return `"${column}"`;
			else
			{
				if (this.show_emp_rating()) 
					return `"${column} - Manager Rating","${column} - Employee Rating"`;
				else 
					return `"${column} - Manager Rating"`;
			}
		}).flat();
		
		csv_content.push(header_row.join(','));
	
		// Add data rows
		this.grouped_results().forEach(result => {
			let row = [];
		
			if (current_visible_columns.includes('Employee'))
				row.push(`"${result.employee_name}"`);
		
			if (current_visible_columns.includes('Company'))
				row.push(`"${result.company_name}"`);
		
			if (current_visible_columns.includes('Department'))
				row.push(`"${result.department_name}"`);
		
			// Add cycle ratings
			this.cycle_names().forEach(cycle_name => {
				if (current_visible_columns.includes(cycle_name)) {
					const cycleRating = result.cycle_ratings[cycle_name];
					
					// Check if employee has any ratings at all
					if (!result.has_ratings) {
						row.push(`"No ratings available"`);
						if (this.show_emp_rating()) {
							row.push(`"No ratings available"`);
						}
					} else {
						// Add manager ratings - group by rating system, then join multiple ratings with semicolon
						const managerRatings = cycleRating?.manager_ratings && cycleRating.manager_ratings.length > 0
							? cycleRating.manager_ratings.map(rs => {
								let system_name = rs.rating_system_name ? `[${rs.rating_system_name}] ` : '';
								let ratings_str = rs.ratings.map(r => `${r.rating_symbol} - ${r.rating_name}`).join('; ');
								return `${system_name}${ratings_str}`;
							}).join(' | ')
							: '-';
						row.push(`"${managerRatings}"`);
					
						// Add employee ratings if showing
						if (this.show_emp_rating()) {
							const employeeRatings = cycleRating?.employee_ratings && cycleRating.employee_ratings.length > 0
								? cycleRating.employee_ratings.map(rs => {
									let system_name = rs.rating_system_name ? `[${rs.rating_system_name}] ` : '';
									let ratings_str = rs.ratings.map(r => `${r.rating_symbol} - ${r.rating_name}`).join('; ');
									return `${system_name}${ratings_str}`;
								}).join(' | ')
								: '-';
							row.push(`"${employeeRatings}"`);
						}
					}
				}
			});
		
			csv_content.push(row.join(','));
		});
	
		let csv_string = csv_content.join('\n');
		let blob = new Blob([csv_string], { type: 'text/csv;charset=utf-8;' });
		let link = document.createElement('a');
	
		link.href = URL.createObjectURL(blob);
		link.setAttribute('download', 'performance_ratings_report.csv');
	
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
	}
	

	update_click()
	{
		this.show_hint(false);
		this.page.updateData();
	}
	page_click(page_number)
	{
		this.current_page_number(page_number);
		this.page.updateData();
	}

	sort_column(column)
	{
		if (column && column.trim() !== '')
		{
			if (this.sort_field() === column)
				this.sort_order(this.sort_order() === 'ASC' ? 'DESC' : 'ASC');
			else
			{
				this.sort_field(column);
				this.sort_order('ASC');
			}
			this.page.updateData();
		}
	}
}

class ReportRatingsPage
{
	constructor(bindings)
	{
		this.bindings = bindings
		this.viewModel = new ReportRatingsViewModel(this)
	}

	async init()
	{
		document.title = tr('Performance Ratings Report')
		window.current_page_title(tr('Performance Ratings Report'))
		// Modified: Don't call updateData on init
	}

	async updateData()
	{
		let data = { include_resigned: this.viewModel.include_resigned() }

		if (this.viewModel.selected_cycle())
			data.cycle_id = this.viewModel.selected_cycle().cycle_id;

		if (this.viewModel.selected_filter_by() == 'employee')
		{
			if (this.viewModel.selected_employee())
				data.employee_id = this.viewModel.selected_employee().employee_id;

			// Reset other selections
			this.viewModel.selected_department(null)
			this.viewModel.selected_company(null)
			this.viewModel.selected_manager(null)
		}
		else if (this.viewModel.selected_filter_by() == 'company')
		{
			if (this.viewModel.selected_company()) 
				data.company_id = this.viewModel.selected_company().company_id;

			this.viewModel.selected_department(null)
			this.viewModel.selected_employee(null)
			this.viewModel.selected_manager(null)
		}
		else if (this.viewModel.selected_filter_by() == 'department')
		{
			if (this.viewModel.selected_department()) 
				data.department_id = this.viewModel.selected_department().department_id;

			this.viewModel.selected_employee(null)
			this.viewModel.selected_company(null)
			this.viewModel.selected_manager(null)
		}
		else if (this.viewModel.selected_filter_by() == 'manager')
		{
			if (this.viewModel.selected_manager()) 
				data.manager_id = this.viewModel.selected_manager().employee_id;

			this.viewModel.selected_employee(null)
			this.viewModel.selected_company(null)
			this.viewModel.selected_department(null)
		}

		let res = await Grape.fetches.postJSON('/reports/performance_management/get_performance_ratings_report', data);
		
		if (res && res.ratings != null)
		{
			let records = res.ratings.map(record => ({
				...record,
				fullnames: record.first_name + ' ' + record.last_name,
				department_company: record.department + ' (' + record.company + ')'
			}));

			res.records = records
			res.total = res.total_count
			res.offset = res.ratings.length
			res.limit = res.ratings.length + 2
			this.viewModel.results(res.ratings)
			this.viewModel.show_hint(false);
			this.viewModel.show_no_data_message(false);
		}

		if (res.total_count == 0)
		{
			this.viewModel.show_no_data_message(true);
			this.viewModel.show_hint(false);
		}
	}
}

export default {
	route: '[/]report/performance_management/ratings_report',
	page_class: ReportRatingsPage,
	template: template,
	template_filename: 'translation/ratings_report'
}